import {Languages} from '@shared/languages';
import {
  mainLandingEnFallback,
  mainLandingFallback,
  mainLandingZhFallback,
} from '@strapi/endpoints/WebLanding/MainLanding/mainLanding.fallback';

export {
  getFooterLocaleFallback as getFooterFallback,
  getHeaderLocaleFallback as getHeaderFallback,
} from '@strapi/utils/getLocaleFallback';

export const getLocalisedEmptySearchResult = (locale?: Languages) => {
  if (!locale) return 'Ничего не найдено';
  switch (locale) {
    case 'en':
      return 'Nothing found';
    case 'zh':
      return '搜索结果为空';
    default:
      return 'Ничего не найдено';
  }
};

export const getLocaleFallback = (locale?: Languages) => {
  if (!locale) return mainLandingFallback;
  switch (locale) {
    case 'en':
      return mainLandingEnFallback;
    case 'zh':
      return mainLandingZhFallback;
    default:
      return mainLandingFallback;
  }
};
